const CODE_DEFINITIONS = {
	11200: 'HTTP retrieval failure',
	11205: 'HTTP connection failure',
	11751: 'Media exceeds messaging provider size limit',
	12300: 'Unknown error',
	30001: 'Queue overflow',
	30002: 'Account suspended',
	30003: 'Unreachable destination handset',
	30004: 'Message blocked',
	30005: 'Unknown destination handset',
	30006: 'Landline or unreachable carrier',
	30007: 'Message filtered',
	30008: 'Unknown error',
	30009: 'Missing inbound segment',
	30010: 'Message price exceeds max price',
	30011: 'MMS not supported by the receiving phone number in this region',
	30012: 'TTL is too small',
	30013: 'TTL is too big',
	30014: 'Phone number attributes are Invalid',
	30015: 'Non-supported channel type is used',
	30016: 'To and From channel types are incompatible',
	30017: 'Carrier network congestion',
	30018: 'Destination carrier requires sender ID pre-registration',
	30019: 'Content size exceeds carrier limit',
	30020: 'Internal Failure with Message Scheduling',
	30021: 'Internal Failure with messaging service orchestrator',
	30022: 'US A2P 10DLC - Rate Limits Exceeded',
	30023: 'US A2P 10DLC - Daily Message Cap Reached',
	30024: 'Numeric Sender ID Not Provisioned on Carrier',
	30032: 'Toll-Free Number Has Not Been Verified',
	30033: 'US A2P 10DLC - Campaign Suspended',
	30034: 'US A2P 10DLC - Message from an Unregistered Number',
	30035: 'US A2P 10DLC - Message from a number still being configured',
	30036: 'Validity Period Expired',
	30037: 'Outbound Messaging Disabled',
	30410: 'Provider Timeout Error',
	30500: 'Twilio Internal Error',
	60005: 'Downstream Carrier Error',
	63019: 'WhatsApp: Bad request (400)',
};

export default function getTwilioErrorDefinition(errorCode: string): string {
	const normalizedCode = Number(String(errorCode).trim());
	const definition =
		CODE_DEFINITIONS[normalizedCode as keyof typeof CODE_DEFINITIONS];
	return definition ?? 'Unkown error';
}
